import { render, staticRenderFns } from "./WinNotice.vue?vue&type=template&id=07481a3c&scoped=true"
import script from "./WinNotice.vue?vue&type=script&lang=js"
export * from "./WinNotice.vue?vue&type=script&lang=js"
import style0 from "./WinNotice.vue?vue&type=style&index=0&id=07481a3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07481a3c",
  null
  
)

export default component.exports